import { LegacyPhotosLinkedToAssetEventV2 } from '../event/legacy-photos-linked-to-asset-v2.event';
const legacyPhotosLinkedToAssetV2Projections = {
    [LegacyPhotosLinkedToAssetEventV2.name]: (_event, state) => ({
        ...state,
    }),
};
export default legacyPhotosLinkedToAssetV2Projections;
//# sourceMappingURL=legacy-photos-linked-to-asset-v2.projection.js.map